var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "med-size-text columns",
      attrs: { id: "prospect-contact-data" },
    },
    [
      _c("div", { staticClass: "prospect-id-number column" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("idNumber")))]),
        _c("br"),
        _c("span", [_vm._v(_vm._s(_vm.prospect.idNumber))]),
      ]),
      _c("div", { staticClass: "prospect-email column" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("email")))]),
        _c("br"),
        _c("span", [_vm._v(_vm._s(_vm.prospect.email))]),
      ]),
      _c("div", { staticClass: "prospect-phone column" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("phone")) + " ")]),
        _c("a", { attrs: { href: _vm.whatsappLink, target: "_blank" } }, [
          _c("i", { staticClass: "fab fa-whatsapp" }),
        ]),
        _c("br"),
        _c("span", [_vm._v(_vm._s(_vm.prospect.phone))]),
      ]),
      _c("div", { staticClass: "prospect-id column" }, [
        _c("strong", [_vm._v("ProspectId")]),
        _c("br"),
        _c("span", [_vm._v(_vm._s(_vm.prospect._id))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }